import { defineStore } from 'pinia';
import { ref } from 'vue';
import { ModalMessage } from '@/types/session';

interface SessionState {
  loading: boolean;
  error: Error | null;
  play_id: number | false;
  displayModal: boolean;
  modalMessage: ModalMessage;
  ticketsUpdated: boolean;
  loginError: boolean;
  loggingOut: boolean;
  gameExited: boolean;
}

export const useSessionStore = defineStore('session', () => {

  const loading = ref(false);
  const error = ref<Error | null>(null);
  const play_id = ref<number | false>(false);
  const ticketsUpdated = ref(false);
  const loginError = ref(false);
  const loggingOut = ref(false);
  const gameExited = ref(false);

  function setLoading(status: boolean) {
    loading.value = status;
  }

  function setError(err: Error | null) {
    error.value = err;
  }

  function setPlayId(id: number | false) {
    play_id.value = id;
  }


  function setTicketsUpdated(updated: boolean) {
    ticketsUpdated.value = updated;
  }

  function setLoginError(error: boolean) {
    loginError.value = error;
  }

  function setLoggingOut(status: boolean) {
    loggingOut.value = status;
  }

  function setGameExited(status: boolean) {
    gameExited.value = status;
  }

  return {
    // State
    loading,
    error,
    play_id,
    ticketsUpdated,
    loginError,
    loggingOut,
    gameExited,

    // Actions
    setLoading,
    setError,
    setPlayId,
    setTicketsUpdated,
    setLoginError,
    setLoggingOut,
    setGameExited,
  };
});
